// `/pitch-deck-reviewer review this` -> ['pitch-deck-reviewer', 'review this'].
// Mirrors parse_slash in backend/src/agents/definitions.py.
const SLASH_RE = /^\/([a-z0-9]+(?:-[a-z0-9]+)*)(?:\s+|$)/;

export function parseSlash(text: string): [string | null, string] {
    const m = SLASH_RE.exec(text);
    if (!m) return [null, text];
    return [m[1], text.slice(m[0].length)];
}

// Fired when an agent's turn finishes. An agent can change the record and the
// workspace's tasks, so surfaces showing either reload on it.
export const AGENT_TURN_DONE_EVENT = 'navaris:agent-turn-done';

// A skill's description says what it does, then when the agent should use it; people
// are shown what it does, its first sentence.
export function whatItDoes(description: string | null | undefined): string {
    const text = (description ?? '').trim();
    const end = text.search(/\.(\s|$)/);
    return end === -1 ? text : text.slice(0, end + 1);
}
